import { render, staticRenderFns } from "./Myscore.vue?vue&type=template&id=6db1db6e&scoped=true"
import script from "./Myscore.vue?vue&type=script&lang=js"
export * from "./Myscore.vue?vue&type=script&lang=js"
import style0 from "./Myscore.vue?vue&type=style&index=0&id=6db1db6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db1db6e",
  null
  
)

export default component.exports